import Vue from 'vue'
import App from './App'
//element-ui的loading
import ElementUI, {Loading} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from "vue-router";
import router from './router'
//基于断点的隐藏类
import 'element-ui/lib/theme-chalk/display.css';
//导入的menu的图标css
import './assets/css/iconStyle/iconfont.css'
//博客编辑器
import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";

import './assets/css/allIcon/iconfont.css';

import SlideVerify from './lib/index'
//解决跨域问题
import {VueJsonp} from "vue-jsonp";

Vue.use(VueJsonp)

Vue.use(SlideVerify)

Vue.config.productionTip = false;


Vue.use(VueRouter)
Vue.use(Loading)
Vue.use(ElementUI)
Vue.use(mavonEditor);

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js